import { AnimatePresence, motion } from 'framer-motion';
import { id } from '@/i18n/id';

export function OfflineBanner({ visible }: { visible: boolean }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          role="alert"
          className="flex items-center justify-center gap-2 bg-state-danger-soft px-6 py-3 text-center text-sm font-semibold text-state-danger"
        >
          <span aria-hidden>⚠</span>
          {id.banner.offline}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
